// @ts-nocheck
import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { useLanguage } from "../LanguageContext";
import { useMediaQuery, useTheme } from "@mui/material";
import Header from "./Header";
import ThemeToggle from "../userDrawer/themeToggle";

const languages = [
  "cz",
  "en",
  "fr",
  "es",
  "nl",
  "sk",
  "de",
  "hu",
  "pl",
  "ru",
  "sv",
  "no",
  "fi",
  "da",
  "ar",
];

interface LanguageDrawerProps {
  open: boolean;
  onClose: () => void;
}

const LanguageDrawer: React.FC<LanguageDrawerProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const { setLanguage } = useLanguage();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(88, 110, 223, .8)",
        },
      }}
      PaperProps={{
        sx: {
          width: isSmallScreen ? "100%" : 384,
          minWidth: 320,
          backgroundColor: "#f0f0f0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
      }}
    >
      <div className="z-30 relative">
        <div className="absolute right-2 top-4" onClick={onClose}>
          <ThemeToggle />
        </div>
        <Header hideLanguageFlag={true} />
      </div>
      <div className="bg-white dark:bg-darkSecondaryBackground w-full h-full">
        <div
          className=" w-full flex flex-wrap justify-center p-4 gap-2 mb-auto"
          onClick={onClose}
          onKeyDown={onClose}
        >
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => handleLanguageChange(lang)}
              className="dark:bg-darkBackground dark:shadow-none shadow p-4 rounded-md cursor-pointer"
            >
              <img
                src={`/flags/${lang}.png`}
                alt={lang}
                className="h-6 w-auto"
              />
            </button>
          ))}
        </div>
      </div>
    </Drawer>
  );
};

export default LanguageDrawer;
